import styled, {css, keyframes} from "styled-components/macro";
import {device} from "styles";
import {IsActive, IsLoading, Size} from "data";

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;


export const Root = styled.button<IsActive>`
    min-height: 36px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    position: relative;

    font-size: 18px;
    line-height: 28px;
    font-weight: 700;
    padding: 20px 90px;
    text-transform: uppercase;

    color: var(--color-accent);
    background: var(--color-border);
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    user-select: none;
    border-radius: 2px;

    ${device.less1180} {
        font-size: 12px;
        padding: 8px 60px;
    }

    ${device.less768} {
        padding: 8px 45px;
    }
    
    &:hover {
        background: var(--color-input-selected);
    }

    ${(props) => props.$isActive && css`
        color: var(--color-accent-reversed);
        background: var(--color-accent);
    `}
`;

export const Text = styled.span<IsLoading & Size>`
    transition: opacity 0.3s;
    font-family: 'Mazzard L', sans-serif;
    font-size: ${props => {
        switch (props.$size) {
            case "small":
                return "14px"
            case "normal":
                return "18px"
            case "large":
                return "24px"
        }
    }};
    
    ${props => props.$isLoading && css`
        opacity: 0.0001;
    `}

    ${device.less768} {
        font-size: ${props => {
            switch (props.$size) {
                case "small":
                    return "10px"
                case "normal":
                    return "12px"
                case "large":
                    return "18px"
            }
        }};
    }
`;

export const Loader = styled.span<IsLoading>`
    width: 30px;
    height: 30px;
    border: 3px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: ${rotate} 1s linear infinite;
    position: absolute;
    transition: opacity 0.3s;
    top: 50%;
    left: 50%;
    margin-left: -15px;
    margin-top: -15px;
    opacity: 0.0001;

    ${props => props.$isLoading && css`
        opacity: 1;
    `}
`;
